// The app no longer uses a service worker. Older builds registered one, and a
// browser that visited back then may still have it, serving stale assets.
// unregister() removes it, so it runs on every page load.
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister()
    })
  }
}
